import { RouteConfig } from 'vue-router'

const Index = () => import('../activity/fall-semester/2024/Index.vue')
const IndexSSPlus = () => import('../activity/fall-semester/2024-ssplus/Index.vue')

const indexRoute: RouteConfig = {
  path: '/activity/fall-semester-2024-desk',
  name: 'activity_fall_semester_2024_desk',
  component: Index,
  props: (route) => ({ ...route.params, ...route.query }),
  meta: {
    title: '焕然一新·书桌装扮活动',
    expiryDate: '2024-04-01',
  },
}

export const indexSSplusRoute: RouteConfig = {
  path: '/activity/fall-semester-2024',
  name: 'activity_fall_semester_2024',
  component: IndexSSPlus,
  props: (route) => ({ ...route.params, ...route.query }),
  meta: {
    title: '新学期驯龙计划',
    expiryDate: '2024-08-01',
  },
}

export default [indexRoute, indexSSplusRoute]
